import { cn } from '@cobliteam/ui/utils';
import type { ReactNode } from 'react';
import { ConversationContent, Conversation as ConversationEl, ConversationScrollButton } from '../elements/Conversation';

type Props = {
  children: ReactNode;
  className?: string;
  classNameContent?: string;
};

const Conversation = ({ children, className, classNameContent }: Props) => (
  <ConversationEl data-testid='ai-chat-messages' className={cn('scroll-container flex-1 scroll-smooth', className)}>
    <ConversationContent className={cn('mx-auto max-w-screen-tablet pr-4', classNameContent)}>{children}</ConversationContent>
    <ConversationScrollButton />
  </ConversationEl>
);

export default Conversation;
